<template>
  <input
    v-model.trim="qrCode"
    class="box"
    style="text-align: left; flex-grow: 1;"
  />
</template>

<script>
export default {
  name: 'QRCodeForm',

  props: {
    value: { type: Object, required: true }, // coupon
  },

  data() {
    return {
      qrCode: this.value.qrCode,
    };
  },

  watch: {
    qrCode(qrCode) {
      this.$emit('input', {
        ...this.value,
        qrCode,
      });
    },
  },
};
</script>
